import { Footer } from '@domgen/base-design-system-2.0/atoms/Footer';
import { HeaderCobranded } from '@domgen/base-design-system-2.0/atoms/HeaderCobranded';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { smoothScrollIntoView } from '@domgen/base-design-system-2.0/animation/smoothScrollIntoView';
import { useAppContext } from './context/AppContext';
import { store } from './store/store';

export const Layout = () => {
  const location = useLocation();
  const { clientLogo, getRouteFromPath } = useAppContext();

  const clientName = import.meta.env.VITE_CLIENT_FRIENDLY_NAME.trim();
  const navigate = useNavigate();
  const links = [
    {
      text: 'Appliance care service plan terms and conditions',
      href: 'https://prod.domesticgeneral.magnolia-platform.io/dam/jcr:42f4b575-10b0-4c30-8001-4d9763184ae0/DG-APP-CARE-COMBINED-v2309.pdf',
    },
    {
      text: `${clientName} Product Support`,
      href: `https://www.${clientName.toLowerCase()}.com/owners.html`,
    },
    { text: `Terms of Use`, href: 'https://www.domesticandgeneral.com/us/terms-and-conditions' },
    {
      text: `Domestic & General privacy notice`,
      href: 'https://www.domesticandgeneral.com/us/security-privacy',
    },
    {
      text: `${clientName} privacy notice`,
      href: 'https://www.whirlpoolcorp.com/privacy-policy.html',
    },
    { text: `Cookies notice`, href: 'https://www.domesticandgeneral.com/us/cookies' },
  ];

  useEffect(() => {
    smoothScrollIntoView(0);
  }, [location.pathname]);

  /** This is where all the navigation events are handled */
  useEffect(() => {
    const sub = store.on('navigate', ({ path, replace }) => {
      navigate(path, { replace });
    });
    return sub.unsubscribe;
  }, [navigate]);

  const getPageTitle = () => {
    const route = getRouteFromPath(location.pathname);
    if (!route) return `${clientName} Registration`;
    return `${clientName} Registration - ${route.title}`;
  };

  return (
    <div className="flex flex-col min-h-screen">
      <HeaderCobranded
        clientIcon={<NavLink to="/">{clientLogo}</NavLink>}
        clientName={clientName}
      />
      <main className="grow flex flex-col">
        <title>{getPageTitle()}</title>
        <Outlet />
      </main>
      <Footer client={`${clientName} Appliance Care`} links={links} />
    </div>
  );
};
